import { render, staticRenderFns } from "./AppSixthScreen.vue?vue&type=template&id=5717c47c&scoped=true"
import script from "./AppSixthScreen.vue?vue&type=script&lang=js"
export * from "./AppSixthScreen.vue?vue&type=script&lang=js"
import style0 from "./AppSixthScreen.vue?vue&type=style&index=0&id=5717c47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5717c47c",
  null
  
)

export default component.exports